import React from "react"
import "./index.scss"

const FormRadio = ({ text, id, name, checked, value, onChange, disabled }) => {
  return (
    <div className="form-radio">
      <input
        id={id}
        name={name}
        type="radio"
        checked={checked}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      <label htmlFor={id} className="radio-label">
        {text}
      </label>
    </div>
  )
}

export default FormRadio
